import type { ReactNode } from 'react';

interface ModuleIntroBannerProps {
  icon: ReactNode;
  title: string;
  body: string;
  onDismiss: () => void;
}

export default function ModuleIntroBanner({ icon, title, body, onDismiss }: ModuleIntroBannerProps) {
  return (
    <div
      style={{
        background: 'var(--gradient-soft)',
        border: '1px solid color-mix(in srgb, var(--color-accent) 35%, transparent)',
        borderRadius: 'var(--radius-lg)',
        padding: '14px 16px',
        marginBottom: 14,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        animation: 'introSlideIn 0.35s ease',
        position: 'relative',
      }}
      role="region"
      aria-label={`${title} intro`}
    >
      <span style={{ fontSize: 'var(--fs-xl-plus)', lineHeight: 1, flexShrink: 0, marginTop: 2 }}>{icon}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: 'var(--fs-sm)', color: 'var(--color-accent)', marginBottom: 3 }}>{title}</div>
        <div style={{ fontSize: 'var(--fs-xs)', color: 'var(--color-text-secondary)', lineHeight: 1.55 }}>{body}</div>
      </div>
      {/* eslint-disable-next-line cw/no-inline-button-style -- ModuleIntroBanner dismiss × — bare text-only icon button in banner header, not a chamfered .btn variant */}
      <button
        onClick={onDismiss}
        aria-label="Dismiss intro"
        style={{
          background: 'none',
          border: 'none',
          color: 'var(--color-text-secondary)',
          fontSize: 'var(--fs-md)',
          cursor: 'pointer',
          padding: '0 2px',
          lineHeight: 1,
          flexShrink: 0,
          alignSelf: 'flex-start',
        }}
      >×</button>
      <style>{`
        @keyframes introSlideIn {
          from { opacity: 0; transform: translateY(-6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @media (prefers-reduced-motion: reduce) {
          * { animation-duration: 0.01ms !important; }
        }
        html.reduced-motion * { animation-duration: 0.01ms !important; transition-duration: 0.01ms !important; }
      `}</style>
    </div>
  );
}
